import React from 'react';
import { Dropdown, Menu } from '@fiverr-private/orca';
import { r_question_circle } from '@fiverr-private/icons';
import { I18n } from '@fiverr-private/i18n-react';
import { useHeaderContext } from '../../../../modern/context/HeaderContext';
import { SellerForumLink, SellerBlogLink } from '../../../SellerLinks';
import { SupportLink } from '../../Links/Support';
import AskTheCommunityLink from '../../Links/AskTheCommunity';
import SellerDropdown from '../../SellerDropdown';

const HelpAndResources = () => {
    const { user } = useHeaderContext();

    return (
        <SellerDropdown
            icon={r_question_circle}
            position={Dropdown.POSITIONS.RIGHT}
            tooltip={<I18n k="header.tooltip.help_and_resources" />}
            menu={
                <Menu className="seller-menu">
                    <Menu.Item>
                        <SellerForumLink sellerId={user.id} />
                    </Menu.Item>
                    <Menu.Item>
                        <SellerBlogLink sellerId={user.id} />
                    </Menu.Item>
                    <Menu.Divider />
                    <Menu.Item>
                        <AskTheCommunityLink />
                    </Menu.Item>
                    <Menu.Item>
                        <SupportLink />
                    </Menu.Item>
                </Menu>
            }
        />
    );
};

export default HelpAndResources;
